const ERROR_QUERY_SELECTOR = '.tp-error';
const SCROLL_TO_ERROR_OFFSET = 90;

export const scrollToElement = (el: Element, topOffset: number = 0) => {
  if (!el || !el.prepend) return;

  const scrollHandle = document.createElement('div');
  scrollHandle.setAttribute('style', `position: relative; top: -${topOffset}px; opacity: 0;`);
  el.prepend(scrollHandle);

  scrollHandle.scrollIntoView({ behavior: 'smooth', block: 'start' });
  scrollHandle.remove();
};

export const scrollToFirstError = () => {
  // wait for errors to be rendered in the DOM
  setTimeout(() => {
    const firstError = document.querySelector(ERROR_QUERY_SELECTOR);
    scrollToElement(firstError, SCROLL_TO_ERROR_OFFSET);
  }, 0);
};

export const scrollToTop = () => {
  window.scroll(0, 0);
};
